module.exports = __webpack_public_path__ + "static/media/tahsilat_screen3.eef1b248.png";